import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HotRanking() {
  const ranked = [...movies]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 10);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-100">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              高分影视排行
            </p>
          </div>
        </div>

        <div className="bg-background-100 rounded-xl p-4 md:p-6">
          {ranked.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="flex items-center gap-3 py-3 border-b border-background-200 last:border-b-0 cursor-pointer hover:bg-background-200/50 rounded-lg px-2 -mx-2 transition-colors"
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                  index < 3
                    ? 'bg-primary-500 text-background-950'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-100 line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {movie.updateInfo}
                </p>
              </div>
              <span className="text-sm font-semibold text-accent-400 flex-shrink-0">
                {movie.rating}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}